import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import 'whatwg-fetch';

export const fetchAuth = createAsyncThunk('auth/fetch', async (site_id) => {
    const params = new URLSearchParams(window.location.search);
    if (site_id) params.set('site_id', site_id);
    try {
        const resp = await fetch(`${process.env.API_URL}/load`, {
            method: 'POST',
            body: params,
        }).then(resp => resp.json());
    
        if (resp && resp.success) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
});

export const login = createAsyncThunk('auth/login', async (credentials) => {
    try {
        const resp = await fetch(`${process.env.API_URL}/auth/login-by-token`, {
            method: 'POST',
            body: new URLSearchParams(credentials),
        }).then(resp => resp.json());
    
        if (resp && resp.success) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
});

export const installScript = createAsyncThunk('auth/install-script', async (_, { getState }) => {
    const params = new URLSearchParams(window.location.search);
    params.set('site_id', getState().auth.data.site_id);
    try {
        const resp = await fetch(`${process.env.API_URL}/auth/install-script`, {
            method: 'POST',
            body: params,
        }).then(resp => resp.json());
    
        if (resp && resp.success) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
});

export const uninstallScript = createAsyncThunk('auth/uninstall-script', async (_, { getState }) => {
    const params = new URLSearchParams(window.location.search);
    params.set('site_id', getState().auth.data.site_id);
    try {
        const resp = await fetch(`${process.env.API_URL}/auth/uninstall-script`, {
            method: 'DELETE',
            body: params,
        }).then(resp => resp.json());
    
        if (resp && resp.success) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
});

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        loading: 'idle',
        data: null,
        loaded: false,
        loginSignedPayload: '',
        scriptProcessing: 'idle',
    },
    reducers: {
        updateExpire: (state, action) => {
            if (!state.data) {
                return;
            }
            state.data.expire = action.payload.expire;
            state.data.trial = false;
        },
    },
    extraReducers: {
        [fetchAuth.pending]: (state) => {
            state.loading = 'pending';
        },
        [fetchAuth.fulfilled]: (state, action) => {
            state.loaded = true;
            state.loading = 'idle';
            state.data = action.payload;
        },
        [login.pending]: (state) => {
            state.loading = 'pending';
        },
        [login.fulfilled]: (state, action) => {
            state.loading = 'idle';
            state.loginSignedPayload = action.payload.signed_payload;
        },
        [installScript.pending]: (state) => {
            state.scriptProcessing = 'pending';
        },
        [installScript.fulfilled]: (state, action) => {
            state.scriptProcessing = 'idle';
            state.data.scriptInstalled = true;
        },
        [uninstallScript.pending]: (state) => {
            state.scriptProcessing = 'pending';
        },
        [uninstallScript.fulfilled]: (state, action) => {
            state.scriptProcessing = 'idle';
            state.data.scriptInstalled = false;
        },
    }
});

export const { updateExpire } = authSlice.actions;

export default authSlice.reducer;